<template>
  <div ref="mapDialog" v-show="showDialog" class="dialog">
    <div class="cloud">
      <div class="title">
        <div>
          <img src="../../assets/img/overview/cloud.png">
          <span>云游览</span>
        </div>
        <i @click="close" class="el-icon-close"></i>
      </div>
      <div class="tabs">
        <div>
          <span class="photo">图片来源：</span>
          <div class="tab" :class="{ 'active': current === item.value }" @click="current = item.value" v-for="(item, index) in tabs" :key="index">{{item.name}}</div>
        </div>
        <div>
          <i @click="type = 0" class="iconfont icon-tupianzhanshi" :class="{ active: type === 0 }"></i>
          <i @click="type = 1" class="iconfont icon-pingpuzhanshi" :class="{ active: type === 1 }"></i>
        </div>
      </div>
      <div class="content">
        <div class="timeline" ref="timeline">
          <div v-for="(item, index) in timeList" :class="{'active': currentTime === item}" :key="index" @click="loadPhoto(item)">{{item.slice(5, item.length)}}</div>
        </div>
        <div class="waterfall" v-if="type === 0">
          <template v-if="current === 4">
            <div class="section" v-if="phoneSignInfo.onSignList && phoneSignInfo.onSignList.length">
              <div class="section-title" @click="signShowIndex = 0">上班签到：{{phoneSignInfo.onSignNum || 0}}人</div>
              <div class="section-ctt" v-if="signShowIndex === 0">
                <Waterfall :list="phoneSignInfo.onSignList" :animationDelay="100" imgSelector="imgUrl" :width="286" backgroundColor="transparent">
                  <template #item="{ url, index }">
                    <div @click="previewImage(phoneSignInfo.onSignList, index)">
                      <LazyImg class="item" :url="url"/>
                    </div>
                  </template>
                </Waterfall>
              </div>
            </div>
            <div class="section" v-if="phoneSignInfo.offSignList && phoneSignInfo.offSignList.length">
              <div class="section-title" @click="signShowIndex = 1">下班签到：{{phoneSignInfo.offSignNum || 0}}人</div>
              <div class="section-ctt" v-if="signShowIndex === 1">
                <Waterfall :list="phoneSignInfo.offSignList" :animationDelay="100" imgSelector="imgUrl" :width="286" backgroundColor="transparent">
                  <template #item="{ url, index }">
                    <div @click="previewImage(phoneSignInfo.offSignList, index)">
                      <LazyImg class="item" :url="url"/>
                    </div>
                  </template>
                </Waterfall>
              </div>
            </div>
            <div class="section section-overtime" v-if="phoneSignInfo.overSignList && phoneSignInfo.overSignList.length">
              <div class="section-title" @click="signShowIndex = 2">
                <span>加班签到：{{phoneSignInfo.overtimeNum || 0}}人</span>
                <span>加班时长：{{phoneSignInfo.overtimeHours || 0}}小时</span>
              </div>
              <div class="section-ctt" v-if="signShowIndex === 2">
                <Waterfall :list="phoneSignInfo.overSignList" :animationDelay="100" imgSelector="imgUrl" :width="286" backgroundColor="transparent">
                  <template #item="{ url, index }">
                    <div @click="previewImage(phoneSignInfo.overSignList, index)">
                      <LazyImg class="item" :url="url"/>
                    </div>
                  </template>
                </Waterfall>
              </div>
            </div>
          </template>
          <template v-else>
            <Waterfall v-if="photoList.length > 0" :list="photoList" :animationDelay="100" imgSelector = "imgUrl" :col-num="4" :width="280" backgroundColor="transparent">
              <template #item="{ item, url, index }">
                <div class="position">
                  <video @click="previewImage(photoList, index)" v-if="item.fileType && videoType.indexOf(item.fileType.toLowerCase()) >= 0" width="100%" height="100%"
                         class="el-upload-list__item-thumbnail"
                         :src="url" controls></video>
                  <div v-else @click="previewImage(photoList, index)">
                    <LazyImg class="item" :url="url"/>
                  </div>
                  <span v-if="current !== 4">{{item.issueContent || item.orderContent || item.facilityName || item.taskNotes}}</span>
                </div>
              </template>
            </Waterfall>
            <img class="noData" v-if= "!photoList.length" src="../../assets/img/overview/noData.png">
          </template>
        </div>
        <template v-if="type === 1">
          <div class="carousel" v-if="photoList && photoList.length && photoList[currentImgIndex]">
            <div class="position">
              <video @click="previewImage(photoList, currentImgIndex)"  v-if="photoList[currentImgIndex].fileType && videoType.indexOf(photoList[currentImgIndex].fileType.toLowerCase()) >= 0"
                     class="el-upload-list__item-thumbnail img"
                     :src="photoList[currentImgIndex].imgUrl" controls></video>
              <el-image v-else @click="previewImage([photoList[currentImgIndex]], currentImgIndex)" :src="photoList[currentImgIndex].imgUrl" class="img"
                        fit="fill">
              </el-image>
              <span v-if="current !== 4">{{photoList[currentImgIndex].issueContent || photoList[currentImgIndex].orderContent || photoList[currentImgIndex].facilityName || photoList[currentImgIndex].taskNotes}}</span>
            </div>
            <div class="items">
              <img class="arrow" @click="setPhoto(-1)" src="../../assets/img/overview/arrow1.png">
              <div ref="scroll">
                <div class="position" v-for="(item, index) in photoList" :key="index" >
                  <video  v-if="item.fileType && videoType.indexOf(item.fileType.toLowerCase()) >= 0" width="100%" height="100%"
                          class="el-upload-list__item-thumbnail item"
                          :src="item.imgUrl" controls @click="previewImage(photoList, index)"></video>
                  <el-image v-else @click="previewImage(photoList, index)" :src="item.imgUrl" class="item"
                            fit="fill">
                  </el-image>
                </div>
              </div>
              <img class="arrow1" @click="setPhoto(1)" src="../../assets/img/overview/arrow1.png">
            </div>
          </div>
          <img class="noData" v-if= "!photoList.length" src="../../assets/img/overview/noData.png">
        </template>
      </div>
    </div>
    <image-viewer :visible.sync="dialogVisible" :isShowText = "true" :append-to-body="false" @hideImageView="hideImageView" :url-list="formatFileList" :initial-index="currentIndex"></image-viewer>
  </div>
</template>

<script>
import { LazyImg, Waterfall } from 'vue-waterfall-plugin'
import 'vue-waterfall-plugin/dist/style.css'
import ImageViewer from '@/components/ImageViewer.vue'
export default {
  name: 'CloudMap',
  props: {
    showDialog: {
      type: Boolean
    }
  },
  components: {
    ImageViewer,
    LazyImg,
    Waterfall
  },
  data () {
    return {
      dialogVisible: false,
      current: 5,
      tabs: [{
        name: '作业日报',
        value: 5
      },
      {
        name: '品质巡查',
        value: 1
      },
      {
        name: '巡查问题',
        value: 2
      },
      {
        name: '任务工单',
        value: 3
      },
      {
        name: '用工签到',
        value: 4
      }],
      photoList: [],
      signShowIndex: 0,
      phoneSignInfo: {},
      type: 0,
      currentIndex: 0,
      currentImgIndex: 0,
      files: [],
      search: {
        startTime: '',
        endTime: ''
      },
      videoType: '.mp4,.mov',
      timeList: [],
      currentTime: ''
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId
    },
    formatFileList () {
      return this.files.map((item) => {
        return { url: (item.imgUrl || item), name: item.fileName || ' ', extra: item.issueContent || item.orderContent || item.facilityName || item.taskNotes || ' ' }
      })
    }
  },
  watch: {
    projectId () {
      this.refreshData()
    },
    current () {
      this.refreshData()
    }
  },
  created () {
    this.getTimeLine()
  },
  destroyed () {
  },
  methods: {
    refreshData () {
      this.photoList = []
      this.getTimeLine()
      this.$refs.timeline.scrollTo({ top: 0 })
    },
    hideImageView () {
      this.files = []
    },
    previewImage (files, index) {
      this.files = files
      this.currentIndex = index
      this.dialogVisible = true
    },
    getTimeLine () {
      this.$axios.get(this.$apis.overview.selectPictureWaterfallFlowDate, {
        type: this.current,
        projectId: this.projectId
      }).then(res => {
        this.timeList = res || []
        this.loadPhoto(this.timeList[0])
      })
    },
    loadPhoto (item) {
      this.currentTime = item
      this.search.startTime = item
      this.search.endTime = item
      this.photoList = []
      this.signShowIndex = 0
      this.phoneSignInfo = {}
      if (this.current === 4) {
        this.loadWaterSignData()
      }
      this.loadData()
    },
    setPhoto (val) {
      if (!(this.currentImgIndex === 0 && val < 0) && !(this.currentImgIndex === this.photoList.length - 1 && val > 0)) {
        this.currentImgIndex += val
        this.$refs.scroll.scrollLeft = 110 * this.currentImgIndex
      }
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.overview.selectPictureWaterfallFlow, {
        ...this.search,
        type: this.current,
        projectId: this.projectId
      }).then(res => {
        this.currentImgIndex = 0
        if (this.current === 4) {
          this.photoList = res.list.map((item) => {
            return { imgUrl: item }
          })
        } else {
          this.photoList = res.list || []
        }
        this.loading = false
      })
    },
    loadWaterSignData () {
      this.loading = true
      this.$axios.get(this.$apis.overview.selectPictureWaterfallSign, {
        ...this.search,
        projectId: this.projectId
      }).then(res => {
        this.phoneSignInfo = res || {}
        this.phoneSignInfo.onSignList = (res.onSignList || []).map((item) => {
          return { imgUrl: item }
        })
        this.phoneSignInfo.offSignList = (res.offSignList || []).map((item) => {
          return { imgUrl: item }
        })
        this.phoneSignInfo.overSignList = (res.overSignList || []).map((item) => {
          return { imgUrl: item }
        })
        // 当没有上班签到时默认展开下班签到的，如果下班签到也没有，默认展开加班签到的
        if (this.phoneSignInfo.onSignList.length === 0) {
          if (this.phoneSignInfo.offSignList.length === 0) {
            this.signShowIndex = 2
          } else {
            this.signShowIndex = 1
          }
        }
        this.loading = false
      })
    },
    close () {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
<style scoped lang='scss'>
  .fullScreen{
    position: absolute;
    bottom: 0px;
    right: 20px;
    cursor: pointer;
  }
  .dialog{
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 999;
  }
  .cloud{
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 1340px;
    height: calc(100% - 127px);
    background: #F3F3F3;
    box-shadow: 0px 14px 20px 0px rgba(53,53,53,0.5);
    border-radius: 10px;
    z-index: 12;
    i{
      cursor: pointer;
    }
    .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 66px;
      border-bottom: 1px solid #EEEFF2;
      padding: 0 30px;
      background: #FFFFFF;
      img{
        margin-right: 10px;
      }
      span{
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 20px;
        color: #000000;
        line-height: 28px;
        text-align: left;
        font-style: normal;
      }
    }

    .iconfont{
      color: #D7DDE1;
      margin-left: 19px;
      &.active {
        color: #000000;
      }
    }
    .tabs{
      display: flex;
      width: 1340px;
      height: 39px;
      line-height: 39px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #000000;
      text-align: left;
      font-style: normal;
      padding: 0 30px;
      background: #FFFFFF;
      >div{
        display: flex;
        flex: 13;
        &:nth-of-type(2){
          flex: 1;
        }
      }

      .photo{
        margin-right: 15px;
      }
      .tab{
        display: flex;
        position: relative;
        font-size: 12px;
        color: #AAAAB1;
        cursor: pointer;
        margin-right: 40px;
        margin-bottom: 12px;
        &.active{
          position: relative;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #0299E5;
          text-align: right;
          font-style: normal;
          &::after{
            content: '';
            position: absolute;
            left: 0px;
            bottom: -12px;
            width: 48px;
            height: 2px;
            background: #4A9EFF;
            border-radius: 8px 8px 0px 0px;
          }
        }
      }
    }

    .content{
      display: flex;
      width: 1370px;
      height: calc(100% - 114px);
      background: #F3F3F3;
      border-radius: 1px 1px 10px 10px;
      padding: 30px 30px 0 0;
      overflow: auto;

      .timeline{
        position: fixed;
        display: flex;
        flex-direction: column;
        width: 83px;
        height: calc(100% - 280px);
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 12px;
        color: #FFFFFF;
        text-align: left;
        overflow: auto;
        padding-left: 30px;
        div{
          position: relative;
          width: 40px;
          height: 14px;
          background: #ACACAC;
          border-radius: 2px;
          margin-bottom: 29px;
          text-align: center;
          line-height: 14px;
          cursor: pointer;

          &.active{
            background: #1577FF;
            &::before{
              background: #0F74FF;
            }
          }
          &::before{
            position: absolute;
            z-index: 3;
            left: -20px;
            top: 3px;
            content: '';
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #ACACAC;
          }

          &::after{
            position: absolute;
            z-index: 2;
            left: -17px;
            top: 3px;
            content: '';
            width: 2px;
            height: 50px;
            background: #E5E5E5;
          }
        }
      }
    }

    .waterfall{
      flex: 1;
      margin-left: 80px;
    }
    .section {
      padding: 12px 20px;
      background: #FFFFFF;
      border-radius: 8px;
      margin: 0 0 10px 8px;
      .section-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        cursor: pointer;
        span {
          margin-right: 44px;
        }
      }
      .section-ctt {
        width: calc(100% + 40px);
        margin-left: -20px;
      }
      &.section-overtime {
        background: linear-gradient( 180deg, #FFE4E4 0%, #FFFFFF 8%, #FFFFFF 100%);
        box-shadow: inset 0px 2px 3px 0px #FFFFFF;
        border: 1px solid #FFCCCC;
      }
    }
    .position{
      position: relative;
      >span{
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 9999;
        width: 100%;
        height: 36px;
        line-height: 36px;
        background: rgba(0,0,0,0.8);
        text-align: left;
        cursor: pointer;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 20px;
      }
    }
    .noData{
      position: absolute;
      left:0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
    }

    .carousel{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 80px;
      .img{
        width: fit-content;
        height: 460px;
        margin: 10px 0 0px 0;
      }

      .items{
        display: flex;
        height: 100px;
        flex-wrap: nowrap;
        align-items: center;
        margin-top: 40px;
        >div{
          display: flex;
          width: 1138px;
          overflow: hidden;
        }
        img{
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
        .item{
          width: 100px;
          height: 100px;
          margin-right: 10px;
          flex-shrink: 0;
        }
        .arrow{
          margin-right: 12px;
        }
        .arrow1{
          margin-left: 12px;
          transform: rotate(180deg);
        }
      }
    }
  }
</style>
